import realEstate from '../../../../public/webp/homePagev2/realEstate.webp';
import fintech from '../../../../public/webp/homePagev2/fintech.webp';
import logistics from '../../../../public/webp/homePagev2/logistics.webp';
import edTech from '../../../../public/webp/homePagev2/edtech.webp';
import FB from '../../../../public/webp/homePagev2/fb.webp';
import healthCare from '../../../../public/webp/homePagev2/hc.webp';
import mobileApp from '../../../../public/webp/homePagev2/mobile-app.webp';
import webApp from '../../../../public/webp/homePagev2/webapp.webp';
import uiux from '../../../../public/webp/homePagev2/uiux.webp';
import qa from '../../../../public/webp/homePagev2/qa.webp';
import digitalMarketing from '../../../../public/webp/homePagev2/dm.webp';
import devopsTech from '../../../../public/webp/homePagev2/dp.webp';
import mobiles from '../../../../public/webp/homePagev2/mobile.webp';
import frontend from '../../../../public/webp/homePagev2/frontend.webp';
import backend from '../../../../public/webp/homePagev2/backend.webp';
import database from '../../../../public/webp/homePagev2/database.webp';
import cms from '../../../../public/webp/homePagev2/cms.webp';
import devops from '../../../../public/webp/homePagev2/devops.webp';

export const homePageData = {
  baddge: 'Accelerate Your Growth with AI',
  heroTitle: `AI-Powered Tech for Smarter Business Results`,
  heroDescription: `Optimity Logics creates AI-powered software solutions that boost productivity, encourage creativity, and facilitate long-term company expansion.`,
  heroContactUsBtn: 'Contact Us',
  heroContactUsBtnLink: '/contact-us',
  trustedClient:
    'Trusted By 250+ Happy Clients, Including Fortune 400 Companies',
  ourExpertiseTitle: 'Our Expertise',
  slides: [
    {
      type: 'animated',
      tab: 'Digital Transformation',
      thumb: '/webp/herov2/digital-transformation-thumb.webp',
      bg: '',
      heading:
        'Engineering AI-Powered Digital Transformation for Global Enterprises',
      description:
        'Helping enterprises and high-growth technology companies modernize legacy systems, build AI-powered products, develop Digital Twin platforms, and scale secure cloud-native applications with dedicated engineering teams.',
      stats: [
        { value: '12+', label: "Years' Experience" },
        { value: '250+', label: 'Projects Delivered' },
        { value: '10+', label: 'In-house Tech Specialists' },
      ],
      primaryCta: { label: 'Talk To Our Experts', href: '/schedule-a-call' },
      secondaryCta: { label: 'View Success Stories', href: '/our-work' },
    },
    {
      type: 'normal',
      tab: 'AI Development',
      thumb: '/webp/herov2/ai-development-thumb.webp',
      bg: '/webp/herov2/ai-development.webp',
      heading: 'Build AI-Native Products That Scale Faster',
      description:
        'From intelligent AI Agents and Generative AI applications to enterprise automation and predictive systems, our AI engineers turn your ideas into production-ready, scalable AI solutions.',
      primaryCta: { label: 'Talk To Our Experts', href: '/schedule-a-call' },
    },
    {
      type: 'normal',
      tab: 'Product Development',
      thumb: '/webp/herov2/product-development-thumb.webp',
      bg: '/webp/herov2/product-development.webp',
      heading: 'Your Product Engineering Partner for the AI Era',
      description:
        'We design, build, and scale digital products end-to-end — from MVP to enterprise-grade platforms — with dedicated teams skilled in AI, cloud, mobile, and modern web technologies.',
      partnerBadges: [
        '/svg/aws-partner-network.svg',
        '/svg/google-cloud-partner.svg',
      ],
      primaryCta: {
        label: 'Build With Us',
        href: '/software-product-development-service',
      },
    },
    {
      type: 'normal',
      tab: 'Team Augmentation',
      thumb: '/webp/herov2/team-augmentation-thumb.webp',
      bg: '/webp/herov2/team-augmentation.webp',
      heading: 'Extend Your Team with Top Global Engineering Talent',
      description:
        'Scale your in-house capabilities on demand with vetted software engineers, AI specialists, cloud architects, DevOps experts, and UX designers who integrate seamlessly with your workflows.',
      primaryCta: { label: 'Hire Dedicated Teams', href: '/contact-us' },
    },
  ],
  ourExpertise: [
    {
      title: 'Mobile App Development',
      description:
        'We create intuitive and interactive mobile applications that elevate your business. Our team specializes in:',
      subDescription: `With years of experience, we've empowered businesses to thrive by providing comprehensive mobile app development services, giving them a competitive edge in their respective industries. `,
      techBenefits: [
        {
          title: 'Native iOS & Android Apps :',
          description:
            ' Leveraging Swift, Kotlin, and Java for seamless performance.',
        },
        {
          title: 'Cross-Platform Development :',
          description: ' Utilizing React Native and Flutter for broader reach.',
        },
        {
          title: 'Hybrid & PWA :',
          description:
            ' Combining the best of web and mobile technologies for enhanced user engagement.',
        },
      ],
      button: 'View All',
      buttonLink: '/our-work',
      img: mobileApp,
    },
    {
      title: 'Web App Development',
      description: `Strengthen your presence in today's digital landscape with our web development services. We specialize in:`,
      subDescription: `Our focus is on delivering scalable web development services to help you gain a competitive edge.`,
      techBenefits: [
        {
          title: 'Custom Web Development :',
          description:
            ' Tailored solutions to meet your unique business requirements.',
        },
        {
          title: 'E-commerce Solutions :',
          description: 'Building robust platforms for online retail.',
        },
        {
          title: 'CMS Development : ',
          description: ' Empowering you to manage content effortlessly.',
        },
        {
          title: 'API & Backend Development : ',
          description: ' Ensuring seamless integration and functionality.',
        },
      ],
      button: 'View All',
      buttonLink: '/our-work',
      img: webApp,
    },
    {
      title: 'UI/UX Design',
      description:
        'Captivate your visitors with mesmerizing web design that enchants from the moment they arrive. Our services include:',
      subDescription: `Our team of creative designers specializes in crafting dynamic websites, web apps, and mobile designs to innovate your business presence.`,
      techBenefits: [
        {
          title: 'Wireframing & Prototyping :',
          description: ' Visualizing the user journey for better clarity.',
        },
        {
          title: 'Responsive Web Design:',
          description: ' Ensuring a seamless experience across devices.',
        },
        {
          title: 'Mobile App Design :',
          description: ' Crafting engaging interfaces for mobile platforms.',
        },
        {
          title: 'Logo & Branding :',
          description: ' Building a strong brand identity.',
        },
      ],
      button: 'View All',
      buttonLink: '/our-work',
      img: uiux,
    },
    {
      title: 'Digital Marketing',
      description:
        'Boost your business with our comprehensive digital marketing services, including:',
      subDescription: `Our team of expert digital marketers specializes in Google Ads, social media management, influencer collaboration, affiliate marketing, email campaigns, and marketing automation.`,
      techBenefits: [
        {
          title: 'SEO & SEM :',
          description: ' Enhancing your online visibility.',
        },
        {
          title: 'Content Writing : ',
          description: ' Engaging your audience with compelling content.',
        },
        {
          title: 'PPC Campaigns :',
          description: ' Driving targeted traffic to your website.',
        },
        {
          title: 'Social Media Marketing :',
          description: ' Building your brand presence on social platforms.',
        },
      ],
      button: 'View All',
      buttonLink: '/our-work',
      img: digitalMarketing,
    },
    {
      title: 'DevOps',
      description:
        'Optimize your design, development, and deployment workflows with our comprehensive suite of DevOps services. We offer:',
      subDescription: `Our DevOps services and solutions enable the development and utilization of high-quality software products and services.`,
      techBenefits: [
        {
          title: 'Infrastructure Management :',
          description: ' Ensuring reliable and scalable systems.',
        },
        {
          title: 'CI/CD Implementation :',
          description: ' Streamlining development and deployment processes.',
        },
        {
          title: 'Network & System Monitoring :',
          description: ' Maintaining optimal performance.',
        },
        {
          title: 'Security Audits :',
          description: ' Identifying and mitigating potential vulnerabilities.',
        },
      ],
      button: 'View All',
      buttonLink: '/our-work',
      img: devopsTech,
    },
    {
      title: 'Quality Assurance',
      description: `Your business's success hinges on the quality of your applications. Our QA services include:`,
      subDescription: `With decades of experience in testing, we understand the diverse perspectives and nuances involved.`,
      techBenefits: [
        {
          title: 'Manual & Automated Testing : ',
          description: ' Ensuring functionality and performance.',
        },
        {
          title: 'Mobile & Web Testing :',
          description:
            ' Covering all platforms for comprehensive quality assurance.',
        },
        {
          title: 'Security Testing :',
          description: ' Protecting your applications from potential threats.',
        },
      ],
      button: 'View All',
      buttonLink: '/our-work',
      img: qa,
    },
  ],

  aiSectionHeqading: 'Automated Data Intelligence',
  aiSectionDescription:
    'Data and AI/ML technologies can revolutionise your company. Find out what you need to know and automate critical processes to increase productivity, efficiency, and long-term growth.',
  aiServices: [
    {
      title: 'Solutions for Data Science',
      description:
        'Customised intelligent data solutions, including data engineering, advanced analytics, and natural language processing (NLP), can help your company realise the full potential of its data.',
    },
    {
      title: 'Progress in AI Research and Development',
      description:
        'Improve your products, automate your processes, and empower your team to make better decisions with the help of our deep AI knowledge.',
    },
    {
      title: 'Advancements in Computer Vision',
      description: `Whether it's object detection, visual analytics, or image recognition, we build bespoke computer vision solutions to meet your specific business needs and boost efficiency.`,
    },
    {
      title: 'The Advancement of Machine Learning',
      description: `Boost your company's performance with cutting-edge solutions, automated processes, and predictive insights made possible by machine learning applied to your datasets.`,
    },
    {
      title: 'Integrating AI',
      description:
        'Maximise value and efficiency by seamlessly integrating advanced AI capabilities—including forecasting, conversational AI, workflow automation, predictive analytics, and more—into your existing systems.',
    },
    {
      title: 'AI Solutions for Generative Tasks',
      description:
        'Intelligent chatbots, financial robo-advisors, IT lifecycle automation, and other next-gen solutions are designed by our generative AI experts to empower your business with cutting-edge AI innovations.',
    },
  ],
  technologyWeWorkTitle: 'Technologies we work with',
  technologyWeWork: [
    {
      techName: 'Mobile',
      techImg: mobiles,
    },
    {
      techName: 'Frontend',
      techImg: frontend,
    },
    {
      techName: 'Backend',
      techImg: backend,
    },
    {
      techName: 'CMS',
      techImg: cms,
    },
    {
      techName: 'Database',
      techImg: database,
    },
    {
      techName: 'DevOps',
      techImg: devops,
    },
  ],
  deployedProjectsTitle: 'Successfully Deployed Projects',
  deployedProjectsList: [
    {
      projectName: 'HTS',
      img: '/webp/project/main/htsv2.webp',
      redirectLink: '/our-work/hts',
    },
    {
      projectName: 'Planned',
      img: '/webp/project/main/planned.webp',
      redirectLink: '/our-work/planned',
    },
    {
      projectName: 'Wikifarmer',
      img: '/webp/project/main/wf.webp',
      redirectLink: '/our-work/wikifarmer',
    },
    {
      projectName: 'Spacerenta',
      img: '/webp/project/main/spacerenta.webp',
      redirectLink: '/our-work/spacerenta',
    },
    {
      projectName: 'Datapacket',
      img: '/webp/project/main/datapacket.webp',
      redirectLink: '/our-work/datapacket',
    },
    {
      projectName: 'Builders Spec',
      img: '/webp/project/main/bs.webp',
      redirectLink: '/our-work/builders-spec',
    },
    {
      projectName: 'E-learning',
      img: '/webp/project/main/edqan.webp',
      redirectLink: '/our-work/edqan',
    },
    {
      projectName: 'Waterboy Rental',
      img: '/webp/project/main/wr.webp',
      redirectLink: '/our-work/waterboy-rentals',
    },
    {
      projectName: 'HaveScripts',
      img: '/webp/project/main/hs.webp',
      redirectLink: '/our-work/havescripts',
    },
    {
      projectName: 'Keto Cycle',
      img: '/webp/project/main/kc.webp',
      redirectLink: '/our-work/keto-cycle',
    },
  ],
  ourIndustriesTitle: 'Our Industries',
  ourIndustries: [
    {
      id: 'real-estate',
      label: 'Real Estate',
      title: 'AI-Powered Real Estate Optimisation',
      description:
        'We develop AI-driven real estate platforms that automate leasing procedures, improve property valuations, and predict changes in the market. Our sophisticated systems combine workflow automation, predictive insights, and geospatial analytics to improve portfolio performance with unparalleled accuracy.',
      sectionTitle: 'Perspectives on Property Value:',
      features: [
        'Predictive analytics models for automated property valuation',
        'Analysis of market sentiment to guide timing and pricing',
        'Dashboards of portfolio performance that provide useful investment signals',
        'Automation of transaction workflow reducing the mean close times',
      ],
      image: realEstate,
      LearnMore: 'Explore Real Estate Solutions',
      link: '/our-work',
    },
    {
      id: 'fintech',
      label: 'Fintech',
      title: 'Fintech Accuracy Driven by AI',
      description:
        'Our AI fintech solutions give banks and financial institutions automated fraud prevention, adaptive compliance tools, and extremely accurate risk modelling. In dynamic financial environments, we provide safe, predictive frameworks that improve decision-making and maintain confidence.',
      sectionTitle: 'Capabilities for Risk Management:',
      features: [
        'Adaptive thresholds for real-time transaction monitoring',
        'Automated KYC checks that incorporate identity verification processes',
        'Predictive analytics-powered credit scoring models',
        'Automation of regulatory reporting greatly lowers compliance overhead.',
      ],
      image: fintech,
      LearnMore: 'Discover FinTech Innovations',
      link: '/our-work',
    },
    {
      id: 'logistics',
      label: 'Logistics',
      title: 'AI-Optimized Logistics Flow',
      description:
        'We create AI-powered logistics ecosystems that automate route planning, predict changes in demand, and provide real-time shipment visibility. Our scalable platforms guarantee agility in changing global supply networks, optimise warehouse operations, and reduce transit delays.',
      sectionTitle: 'Efficiency in Operations Measures:',
      features: [
        'Fuel consumption and distance are decreased by predictive routeing.',
        'Utilisation rates are consistently improved by dynamic load balancing.',
        'visibility in real time throughout the entire delivery network',
        'Autonomous scheduling consistently reduces delays and downtime.',
      ],
      image: logistics,
      LearnMore: 'View Logistics Optimization',
      link: '/our-work',
    },
    {
      id: 'edtech',
      label: 'EdTech',
      title: 'EdTech AI Learning Customisation EdTech',
      description:
        'Our AI-powered EdTech platforms offer predictive learning analytics, real-time performance monitoring, and flexible curriculum pathways. With safe, scalable frameworks, we enable educational institutions to enhance student engagement, personalise instruction at scale, and attain quantifiable academic success.',
      sectionTitle: 'Features of Adaptive Learning:',
      features: [
        'Learner analytics-powered personalised learning pathways',
        'Grading procedures that are automated lowering the workload of instructors considerably',
        'Targeted intervention strategies informed by engagement analytics In a timely manner',
        'Scalable platform architecture that facilitates environments for blended learning',
        'Change the Way People Learn',
      ],
      image: edTech,
      LearnMore: 'See EdTech Transformations',
      link: '/our-work',
    },
    {
      id: 'food-beverage',
      label: 'Food and Beverage',
      title: 'AI-Refined Food and Drink Systems',
      description:
        'In food and beverage operations, we create AI solutions that predict consumer demand, streamline supply chains, and protect product quality. Our intelligent platforms facilitate quick decision-making, increase consistency, and cut waste for long-term, sustainable industry growth.',
      sectionTitle: 'Drivers of Operational Efficiency:',
      features: [
        'Forecasting demand and streamlining production and procurement schedules',
        'Stockouts and excess inventory are decreased by automated replenishment.',
        'Consistent product standards are guaranteed by AI quality monitoring.',
        'Optimising the production line for effective throughput control',
      ],
      image: FB,
      LearnMore: 'Explore Food & Beverage Tech',
      link: '/our-work',
    },
    {
      id: 'healthCare',
      label: 'Healthcare',
      title: 'Advances in Healthcare Driven by AI',
      description:
        'Our AI-powered medical systems streamline hospital resource management, expedite diagnostics, and customise treatment regimens. By utilising predictive analytics, patient data modelling, and advanced medical imaging, we improve results while maintaining operational excellence and compliance.',
      sectionTitle: 'Clinical Impact Measures:',
      features: [
        'Early detection rates are consistently increased by predictive diagnostics.',
        'Effectively prioritising critical patient care through automated triage',
        'Automation of clinical workflow greatly lessens the administrative load.',
        'Optimising resource allocation during times of high demand',
      ],
      image: healthCare,
      LearnMore: 'Discover Healthcare Solutions',
      link: '/our-work',
    },
  ],
  contactUsCardTitle: 'Let’s Build Something Great Together',
  contactUsCardBtn: 'Contact Us',
  contactUsCardBtnLink: '/contact-us',
  clientReview: [
    {
      id: 1,
      message:
        'We are grateful that Optimity Logics joined our project as a Next.js / React / Tailwind developer. Optimity Logics is a top-tier team that delivers features and fixes at a very fast pace with high quality. The quality and reliability of their work significantly reduce testing and project management effort. They communicate effectively: they are responsive, proactive, and kept us informed throughout the entire project. We believe Optimity Logics is a highly valuable asset to any project and our top choice when seeking to expand our front-end engineering team.',
      role: '- CTO (Greece)',
      avatar: '/client/PK.webp',
    },
    {
      id: 2,
      message:
        'Optimity Logics was an absolute pleasure to work with! They did a wonderful job building our website on Contentful and went above and beyond by providing best practices and guidance for our team to use moving forward. They operated as dedicated and thoughtful members of our organization throughout the project. The end result delighted everyone on our team, including exec leadership. I would recommend them to anyone looking for web or IT work. I hope to work with them again in the future!',
      role: '- PR Manager (USA)',
      avatar: '/client/EB.webp',
    },
    {
      id: 3,
      message:
        "I am thrilled to share my experience working with Optimity Logics. They did an outstanding job migrating our production server flawlessly, ensuring our product's stability. Additionally, they identified and resolved an existing issue with the AutoDesk Viewer, including 360 View, Floor Plan, 3D Model, and Gallery View integration. I am extremely impressed with their responsiveness, expertise, and dedication to this task. Optimity Logics' work exceeded my expectations, and I will definitely keep them in mind for future projects. Highly recommended!",
      role: '- CEO (UK)',
      avatar: '/client/MB.webp',
    },
    {
      id: 4,
      message:
        "I recently had the pleasure of collaborating with Optimity Logics on a development project, and their performance exceeded all expectations. The team demonstrated exceptional expertise, professionalism, and dedication throughout the project, showcasing a profound understanding of the task at hand. Their technical proficiency was evident in every aspect, from meticulous planning to flawless execution, combined with a proactive approach to problem-solving and a commitment to delivering high-quality results. Communication was seamless, with regular updates and prompt resolutions to any concerns, ensuring smooth progress from start to finish. Optimity Logics went above and beyond to meet our needs, and their contributions were invaluable to the project's success. I am immensely grateful for their work and would not hesitate to recommend them to anyone seeking skilled and reliable development partners.",
      role: '- CEO (Nigeria)',
      avatar: '/client/KO.webp',
    },
    {
      id: 5,
      message:
        'The Optimity Logics team showcased outstanding expertise in Fullstack development. Their collaborative efforts resulted in timely delivery and exceptional communication throughout the project. I would confidently engage their team again and wholeheartedly recommend them to others.',
      role: '- Founder and Senior Manager (USA)',
      avatar: '/client/NP.webp',
    },
    {
      id: 6,
      message:
        'Optimity Logics did an amazing job bringing complex user stories and requirements to life through their invaluable knowledge and expertise. We appreciate all the feedback, guidance, and encouragement they provided to our junior developers. They are easy to communicate with and ask the right questions. They were consistent with daily scrum meetings and displayed great leadership skills.',
      role: '- Sr. Ventures Manager (USA)',
      avatar: '/client/MP.webp',
    },
    {
      id: 7,
      message:
        'The Optimity Logics team excelled in delivering the project within a tight timeframe, maintaining exemplary coding standards, and achieving remarkable results. Their proficiency in React, Node.js, MongoDB, Express, and AWS was evident. I highly recommend their top-notch development services and look forward to future collaborations.',
      role: '- Product Owner (UK)',
      avatar: '/client/JJ.webp',
    },
    {
      id: 8,
      message:
        ' Optimity Logics excelled with our website project, delivering exceptional results promptly. Their efficiency and dedication to excellence impressed us. Dealing with Optimity Logics is always a pleasure; their team exemplifies professionalism and expertise. We eagerly anticipate future collaborations with such a standout company.',
      role: '- Founder and CEO (USA)',
      avatar: '/client/MS.webp',
    },
    {
      id: 9,
      message:
        'Optimity Logics executed a flawless server migration, showcasing AWS expertise. Their swift work, coupled with invaluable support, was remarkable. We extend heartfelt gratitude for their outstanding service.',
      role: '- General Manager (USA)',
      avatar: '/client/KP.webp',
    },
  ],
  faqTitle: 'FAQs',
  faqsDescription: 'We’ve compiled the answers to your burning questions!',
  getInTouchBtn: 'Get In Touch',
  getInTouchBtnLink: '/schedule-a-call',
  faqsList: [
    {
      question: 'How can I get started with Optimity Logics?',
      answer: `Simply contact us to discuss your project. We'll schedule a consultation to understand your requirements and craft a tailored solution.`,
    },
    {
      question:
        'How does Optimity Logics incorporate emerging technologies into digital transformation strategies?',
      answer:
        'Optimity Logics leverages the latest technologies, including AI, IoT, React Native, Flutter, and cloud platforms like AWS and Azure, to build innovative digital solutions. They integrate these technologies strategically to enhance business processes and create competitive advantages for clients across industries.',
    },
    {
      question:
        'How do you ensure the scalability of solutions for future growth?',
      answer:
        'All solutions are built with modular architecture and cloud-ready frameworks, allowing easy scaling to accommodate business growth, higher traffic, and future enhancements without compromising performance.',
    },
    {
      question: 'How do you ensure projects are delivered on time?',
      answer:
        'Optimity Logics follows Agile project management practices with clearly defined milestones, regular updates, and continuous collaboration with clients to ensure timely delivery while maintaining quality standards.',
    },
    {
      question:
        ' How do you make sure solutions remain adaptable to future technological changes?',
      answer:
        'By using forward-compatible technologies, flexible APIs, and modular system designs, Optimity Logics ensures that your digital products can easily adapt to new tools, frameworks, and industry trends in the future.',
    },
    {
      question:
        'How are security concerns addressed in digital transformation projects?',
      answer:
        'Security is embedded into every stage of development. Optimity Logics implements best practices, including secure coding, vulnerability testing, data encryption, authentication protocols, and continuous system monitoring.',
    },
    {
      question: 'Do you provide ongoing support, updates, and maintenance?',
      answer:
        'Yes, Optimity Logics offers end-to-end support including software updates, performance monitoring, bug fixes, and system maintenance to ensure your solutions remain secure, efficient, and up-to-date.',
    },
  ],
  contactUsFormTitle:
    'We’re Here to <span class="text-red">Help, Anytime.</span>',
  contactUsFormDescription:
    'Our support team is ready to provide prompt solutions and guidance to ensure your experience with us is seamless and satisfying.',
  contactNumber: ' +91 635 301 5499',
  contactEmail: 'info@optimitylogics.com',
  formFirstName: 'First Name*',
  formLastName: 'Last Name*',
  formEmail: 'Email Address*',
  formSubject: 'Subject*',
  formDescription: 'Description*',
  formSubmitBtn: 'Submit',
  companyLocation:
    'A-566, Money Plant High Street, Jagatpur Road, Sarkhej - Gandhinagar Hwy, nr. BSNL Office, Gota, Ahmedabad, Gujarat 382470',
};
